import React from "react";
import { useHistory } from "react-router-dom";
import { REQUISITION_URL } from "../../utils/urlConstants";
import { WarningIcon } from "../../assets/iconComponents/Warning";
import { NameWrapper } from "./Grid.styles";
import { CellRendererProps } from "./types";

export const NameCell: React.FC<CellRendererProps> = ({
  data,
  tabType,
  deviceType,
  context,
}) => {
  const history = useHistory();
  return (
    <div
      onClick={() => {
        if (deviceType !== "desktop") {
          localStorage?.setItem(
            `btoProviderCurrentPage${tabType}`,
            JSON.stringify(context?.currentPage ?? 0),
          );
          if (data.sfID) {
            history.push(`${REQUISITION_URL}/${data.sfID}`);
          }
        }
      }}
    >
      <NameWrapper
        isMissing={data.missingInfo}
        deviceType={deviceType}
        className="grid-name-cell"
      >
        <>
          {data.name}
          {data.missingInfo && <WarningIcon />}
        </>
      </NameWrapper>
    </div>
  );
};
